import SectionCard from '../ui/SectionCard';
import SelectableCard from '../ui/SelectableCard';
import RadioCardGroup from '../ui/RadioCardGroup';

/**
 * One-time services added to the order.
 *
 * Hidden in production behind REACT_APP_FEATURE_ONETIME. `enabled` is a prop, not a
 * module-level FEATURES read, so tests can render it both ways directly.
 *
 * NOTE: the "Stock Photos" entry in product-config previously carried
 * lookup_key: 'setup_fee' -- identical to the real setup fee. Enabling this section with that
 * collision in place would have charged $99 twice under the wrong label. It now uses
 * stock_photos_addon, and buildCatalogIndex throws on any future duplicate. A matching Stripe
 * price must exist before this flag is switched on (see scripts/PRICE-AUDIT.md).
 *
 * @param {object} props
 * @param {boolean} props.enabled
 * @param {object[]} props.products    already filtered by visibility
 * @param {object} props.selected      { [productId]: boolean }
 * @param {Function} props.onToggle    (productId) => void
 */
export default function OneTimeServicesSection({ enabled, products, selected, onToggle }) {
  if (!enabled || !products?.length) return null;

  return (
    <SectionCard
      title="One-Time Services"
      icon="scale"
      description="Optional one-time additions to your order:"
    >
      <RadioCardGroup legend="One-time services" className="flex flex-col rounded-sm border border-gray-200">
        {products.map((product) => (
          <SelectableCard
            key={product.id}
            density="row"
            type="checkbox"
            id={`onetime-${product.id}`}
            name={`onetime-${product.id}`}
            value={product.id}
            checked={!!selected[product.id]}
            onChange={() => onToggle(product.id)}
            title={product.name}
            subtitle={product.description}
            priceLabel={
              typeof product.price_display === 'number'
                ? `$${product.price_display.toFixed(2)}`
                : undefined
            }
            priceSuffix="One-time"
          />
        ))}
      </RadioCardGroup>
    </SectionCard>
  );
}
